var map = {
	"./arrow-down.svg": 3148,
	"./background-desktop.jpg": 7924,
	"./background-mobile.jpg": 3640,
	"./close.svg": 5808,
	"./forbes-logo-weiß-Neu.svg": 9395,
	"./forbes-logo-weiß.svg": 8636,
	"./influence.vision.svg": 4985,
	"./menu-button.svg": 1246,
	"./top-creators-2025-logo.svg": 4313,
	"./vw.svg": 7897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 840;